<template>
  <div class="overall-bg">
    <b-container fluid="xl">
      <b-row>
        <b-col>
          <BacktoPage path="/agreementMasterTableview"></BacktoPage>
        </b-col>
      </b-row>

      <b-row class="form-white-bg mt-4">
        <b-col>
          <b-row class="my-3">
            <b-col lg="4" md="4">
              <p class="compo-heading ps-0">
                {{ t("assetManagement.agreementMaster.detailsheader") }}
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2" md="2">
              <p class="light-txt">Agreement ID</p>
            </b-col>
            <b-col lg="2" md="2">
              <p>: {{ AgreementData?.Id }}</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2" md="2">
              <p class="light-txt">Asset ID</p>
            </b-col>
            <b-col lg="2" md="2">
              <p>: {{ AgreementData?.AssetID }}</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2" md="2">
              <p class="light-txt">Agreement Type</p>
            </b-col>
            <b-col lg="2" md="2">
              <p>: {{ AgreementData?.AgreementType }}</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2" md="2">
              <p class="light-txt">Start Date</p>
            </b-col>
            <b-col lg="2" md="2">
              <p>: {{ AgreementData?.AgreementStartDate }}</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2" md="2">
              <p class="light-txt">End Date</p>
            </b-col>
            <b-col lg="2" md="2">
              <p>: {{ AgreementData?.AgreementEndDate }}</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2" md="2">
              <p class="light-txt">Provider</p>
            </b-col>
            <b-col lg="2" md="2">
              <p>: {{ AgreementData?.Provider }}</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2" md="2">
              <p class="light-txt">Agreement Status</p>
            </b-col>
            <b-col lg="2" md="2">
              <p>: {{ AgreementData?.AgreementStatus }}</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2" md="2">
              <p class="light-txt">Renewal Terms</p>
            </b-col>
            <b-col lg="2" md="2">
              <p>: {{ AgreementData?.RenewalTerms }}</p>
            </b-col>
          </b-row>
          <b-row class="mt-5 mb-3">
            <b-col lg="4" md="4">
              <p class="compo-heading ps-0">
                {{ t("assetManagement.agreementMaster.coveragedetails") }}
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12" md="12" sm="12" cols="12" class="pe-0 mb-3">
              <div class="field label-d-none">
                <CustomTextArea name="" label="" :rules="{ required: false }" id="" :rows="textarearow"
                  :disabled="true" />
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2" md="2">
              <p class="light-txt">Payment Schedule</p>
            </b-col>
            <b-col lg="2" md="2">
              <p>: {{ AgreementData?.PaymentSchedule }}</p>
            </b-col>
          </b-row>
          <b-row class="mt-5 mb-3">
            <b-col lg="4" md="4">
              <p class="compo-heading ps-0">
                {{ t("assetManagement.agreementMaster.notes") }}
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12" md="12" sm="12" cols="12" class="pe-0 mb-3">
              <div class="field label-d-none">
                <CustomTextArea name="" label="" :rules="{ required: false }" id="" :rows="textarearow"
                  :disabled="true" />
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2" md="2">
              <p class="light-txt">Created At</p>
            </b-col>
            <b-col lg="2" md="2">
              <p>: {{ AgreementData?.CreatedAt }}</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2" md="2">
              <p class="light-txt">Created By</p>
            </b-col>
            <b-col lg="2" md="2">
              <p>: {{ AgreementData?.CreatedBy }}</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2" md="2">
              <p class="light-txt">Updated At</p>
            </b-col>
            <b-col lg="2" md="2">
              <p>: {{ AgreementData?.UpdatedAt }}</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2" md="2">
              <p class="light-txt">Updated By</p>
            </b-col>
            <b-col lg="2" md="2">
              <p>: {{ AgreementData?.UpdatedBy }}</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="d-flex flex-row-reverse">
              <AddButton btnname="Edit Agreement" @click="editagreement" />
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch } from "vue";
import { useI18n } from "vue-i18n";
import Headerlayout from "../../../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../../../components/FormComponents/BacktoMaster.vue";
import CustomTextArea from "../../../../../../../components/FormComponents/TextArea.vue";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import AgreementMasterService from "../../../../../../../modules/Inventory/Service/AssetManagement/AgreementMasterService";

export default defineComponent({
  components: {
    Headerlayout,
    BacktoPage,
    CustomTextArea,
  },

  setup() {
    //Variable Deceration
    const { t } = useI18n();
    const textarearow = ref(3);
    const router = useRouter();
    const routers = useRoute();
    let loading = ref(false);
    const AgreementId: any = Number(routers.query.Id);
    const AgreementData = ref();

    onMounted(() => {
      debugger;
      AgreementDetails();
    });

    //
    //Function
    const editagreement = () => {
      router.push({
        path: "/agreementMasterCreation",
        query: {
          Id: AgreementId,
        },
      });
    };

    async function AgreementDetails() {
      debugger;
      loading.value = true;

      try {
        debugger;
        const response = await AgreementMasterService.getfindonedata(
          AgreementId
        );
        let data = response["result"][0];
        AgreementData.value = data;

        // Object.keys(isForm.value).forEach((key) => {
        //   if (data[key]) isForm.value[key] = data[key];
        // });
        // isForm.value.AssetID = data.assetbarcode;
        // assetObj = data.assetObj;
        // console.log(isForm);

        loading.value = false;
      } catch (error) {
        loading.value = false;

        alert(error);
      }
    }
    //
    return {
      t,
      textarearow,
      editagreement,
      AgreementData,
    };
  },
});
</script>

<style lang="scss" scoped></style>
